import type { components } from '../../api/generated/schema'

type Schema = components['schemas']

export type DraftSummary = Schema['DraftSummaryDto']
export type DraftPreview = Schema['DraftPreviewDto']
export type DraftChange = Schema['DraftChangeDto']
export type DraftKind = Schema['DraftKind']
export type DraftStatus = Schema['DraftStatus']
export type ValidationIssue = Schema['ValidationIssue']

/** Human labels for the six things the assistant can propose. */
export const DRAFT_KIND_LABELS: Record<DraftKind, string> = {
  CreateCharacter: 'New character',
  Skills: 'Skill spread',
  Ability: 'Custom ability',
  LibraryAbilities: 'Abilities',
  MagicItem: 'Magic item',
  RoteSpells: 'Rote spells',
}

/**
 * Whether a draft is still awaiting an answer.
 *
 * The server already excludes lapsed drafts from a `Pending` listing and reports a lapsed one as
 * `Expired`, so this is a rendering convenience rather than a second opinion — the client never
 * decides on its own that a draft has run out.
 */
export function isAnswerable(draft: DraftSummary): boolean {
  return draft.status === 'Pending'
}

/** Whether the draft carries findings that stop it being applied. */
export function hasBlockingErrors(draft: DraftSummary): boolean {
  return (draft.errorCount ?? 0) > 0
}
